import { defineModule } from '@core/modules';
import { ModulePath, ModuleTitle } from '@common/types';
import DocumentsArchive from './containers';

export default defineModule({
  title: ModuleTitle.DocumentsArchive,
  path: ModulePath.DocumentsArchive,
  component: DocumentsArchive
});
